import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { getTranslations } from "../../services/languageUtils";
import accountManagerService from "../../services/Celcoin/accountManagerService";

class RegisterVerification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      code: "",
      isLoading: false,
      validationErrors: {},
      translations: {},
    };
  }

  loadTranslations = async () => {
    const translations = await getTranslations(
      localStorage.getItem("language") || "pt",
    );
    this.setState({ translations });
  };

  componentDidMount() {
    this.loadTranslations();
  }

  handleFieldChange = (fieldName, value) => {
    this.setState({
      [fieldName]: value,
      validationErrors: {
        ...this.state.validationErrors,
        [fieldName]: null,
      },
    });
  };

  validateForm = () => {
    const errors = {};

    if (!this.state.email) {
      errors.email = "E-mail é obrigatório";
    } else if (!this.state.email.includes("@")) {
      errors.email = "E-mail inválido";
    }

    if (!this.state.code) {
      errors.code = "Código de verificação é obrigatório";
    }

    this.setState({ validationErrors: errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = async () => {
    if (!this.validateForm()) {
      return;
    }

    this.setState({ isLoading: true });

    try {
      const response = await accountManagerService.validateRegister({
        email: this.state.email,
        code: this.state.code,
      });

      const isSuccess =
        response && response.status >= 200 && response.status < 300;

      if (isSuccess) {
        sessionStorage.setItem("registerVerified", "true");
        sessionStorage.setItem("registerEmail", this.state.email);
        sessionStorage.setItem("registerCode", this.state.code);
        sessionStorage.setItem("registerTimestamp", Date.now().toString());

        toast.success("Verificação realizada com sucesso!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        setTimeout(() => {
          window.location.href = "/register";
        }, 2000);
      }
    } catch (error) {
      console.error("Erro na verificação:", error);

      let errorMessage = "Erro ao verificar código. Tente novamente.";

      if (error.response) {
        switch (error.response.status) {
          case 400:
            errorMessage = "Código inválido ou expirado";
            break;
          case 404:
            errorMessage = "Email não encontrado";
            break;
          case 422:
            errorMessage = "Dados inválidos. Verifique as informações.";
            break;
          default:
            errorMessage = "Erro interno. Tente novamente mais tarde.";
        }
      }

      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { translations, isLoading, validationErrors } = this.state;

    return (
      <section id="mainContent" className="mainContent registerPage">
        <div
          className="sideLeftContent"
          style={{ height: "1800px", minHeight: "105vh" }}
        >
          <div className="textContent">
            <div className="logoLeft">
              <img
                src={require("../../assets/imgs/higher-logo-v2-bl.png")}
                style={{ height: "80px" }}
                alt={translations.iconHigher}
                className="iconHigherImage"
              />
            </div>
            <br />
            <div>
              <div className="contentNumbers">
                <div className="iconNumber iconNumberSelected">1</div>
                <div className="textNumberSelected">
                  Verificação de Email
                  <img
                    src={
                      require("../../assets/imgs/seta-right-branca.svg").default
                    }
                    alt="Ativo"
                    className="checkIcon"
                  />
                </div>
              </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <p className="h3">Compromisso do Higher</p>
            <br />
            <p className="h4">Seus dados estão protegidos</p>
            <br />
            <br />
            <p className="h4">Correspondente Bancário Autorizado</p>
            <br />
            <img
              src={require("../../assets/imgs/banco-central-do-brasil-logo-3@2x-white.png")}
              style={{ height: "40px" }}
              alt="Banco Central"
            />
          </div>
        </div>

        <div
          className="sideLeftContentMobile"
          style={{ padding: "5px 0px 3px 0px" }}
        >
          <div
            className="logoLeft"
            style={{ color: "#fff", textAlign: "center", fontSize: "22px" }}
          >
            <img
              src={require("../../assets/imgs/higher-logo-v2-bl.png")}
              style={{ height: "50px" }}
              alt={translations.iconHigher}
              className="iconHigherImage"
            />
          </div>
        </div>

        <div className="contentStatus">
          <p className="h1">Progresso</p>
          <div className="contentStatusBar">
            <div
              className="contentStatusCurrent"
              style={{ width: "50%" }}
            ></div>
          </div>
        </div>

        <div className="sideRightContent">
          <div className="textContentSteps">
            <div className="h1">
              <div className="h1Label">
                <img
                  src={
                    require("../../assets/imgs/ico-higher-titulo.svg").default
                  }
                  alt="Logo Higher"
                  className="titleImage"
                />
              </div>
              <div className="h1LabelMobile">1</div>
              Verificação de Email
            </div>
            <br />
            <p className="h5">
              Insira seu email e o código de verificação recebido
            </p>

            <div>
              <div className="contentInputText">
                <p className="label">Email *</p>
                <input
                  className={`input ${validationErrors.email ? "inputDanger" : ""}`}
                  type="email"
                  value={this.state.email}
                  onChange={(e) =>
                    this.handleFieldChange("email", e.target.value)
                  }
                  placeholder="Digite seu email"
                  disabled={isLoading}
                  maxLength="150"
                />
                {validationErrors.email && (
                  <span
                    style={{
                      color: "#FF460C",
                      fontSize: "12px",
                      display: "block",
                      marginTop: "5px",
                    }}
                  >
                    {validationErrors.email}
                  </span>
                )}
              </div>

              <div className="contentInputText">
                <p className="label">Código de Verificação *</p>
                <input
                  className={`input ${validationErrors.code ? "inputDanger" : ""}`}
                  type="text"
                  value={this.state.code}
                  onChange={(e) =>
                    this.handleFieldChange("code", e.target.value)
                  }
                  placeholder="Digite o código recebido"
                  disabled={isLoading}
                  maxLength="20"
                />
                {validationErrors.code && (
                  <span
                    style={{
                      color: "#FF460C",
                      fontSize: "12px",
                      display: "block",
                      marginTop: "5px",
                    }}
                  >
                    {validationErrors.code}
                  </span>
                )}
              </div>

              <div className="lineBtnSaveAndContinue">
                <div
                  className="btnSaveAndContinue"
                  onClick={undefined}
                  style={{
                    opacity: 0.6,
                    cursor: "not-allowed",
                    width: "150px",
                    backgroundColor: "#6c757d",
                    borderColor: "#6c757d",
                  }}
                >
                  Voltar ao Login
                </div>
                <div
                  className="btnSaveAndContinue"
                  onClick={!isLoading ? this.handleSubmit : undefined}
                  style={{
                    opacity: isLoading ? 0.6 : 1,
                    cursor: isLoading ? "not-allowed" : "pointer",
                    width: "300px",
                  }}
                >
                  {isLoading ? "Verificando..." : "Verificar e Continuar"}
                  {!isLoading && (
                    <div className="arrow">
                      <img
                        src={
                          require("../../assets/imgs/seta-right-branca.svg")
                            .default
                        }
                        alt="Próximo"
                        className="arrowNext"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer />
      </section>
    );
  }
}

export default RegisterVerification;
